import Item from 'owa-service/lib/contract/Item';
import { ComposeViewState, ComposeOperation } from 'owa-mail-compose-store';
import { InternetHeaders } from 'owa-addins-core';
import {
    updateViewStateWithAnyMissingHeaders,
    tryGetHeaders,
} from '../../utils/InternetHeaderUtils';

export const getComposeInternetHeaders = (viewState: ComposeViewState) => async (
    headerNames: string[]
): Promise<InternetHeaders> => {
    if (viewState.operation === ComposeOperation.EditDraft) {
        await updateViewStateWithAnyMissingHeaders(viewState, headerNames);
    }

    return [...viewState.internetHeaders.keys()]
        .filter(key => headerNames.includes(key))
        .reduce((dictionary, key) => {
            dictionary[key] = viewState.internetHeaders.get(key);
            return dictionary;
        }, {});
};

export const getReadInternetHeaders = (item: Item) => async (
    headerNames: string[]
): Promise<InternetHeaders> => {
    return await tryGetHeaders(headerNames, item.ItemId.Id);
};
